import { Pressable } from 'react-native'

import { styled } from '~/core/styled'

export const Trigger = styled(Pressable, theme => {
  return {
    base: {
      paddingHorizontal:
        theme.paddingInsetOnepulse + theme.paddingInsetTwopulse,

      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',

      gap: theme.spacingInlineOnepulse,

      borderWidth: theme.borderWidthHalfpulse,
      borderColor: theme.colorFormsBorderDefault,
      borderRadius: theme.borderRadiusForm,

      overflow: 'hidden',

      backgroundColor: theme.colorFormsFillDefault,
    },
    variants: {
      size: {
        md: {
          height: theme.sizingMedium,
        },
        ml: {
          height: theme.sizingMediumlarge,
        },
        lg: {
          height: theme.sizingLarge,
        },
        xl: {
          height: theme.sizingExtralarge,
        },
      },
      isFocused: {
        true: {
          borderWidth: theme.borderWidthHalfpulse,
          // borderColor: theme.colorFormsBorderFocused,
          // @TODO: update design tokens
          borderColor: 'black',

          backgroundColor: theme.colorFormsFillFocused,
        },
      },
      isFilled: {
        true: {
          borderWidth: theme.borderWidthQuarterpulse,
          borderColor: theme.colorFormsBorderFilled,

          backgroundColor: theme.colorFormsFillFilled,
        },
      },
      isDisabled: {
        true: {
          borderWidth: theme.borderWidthQuarterpulse,
          borderColor: theme.colorFormsBorderDisabled,

          backgroundColor: theme.colorFormsFillDisabled,
        },
      },
      isReadOnly: {
        true: {
          borderWidth: theme.borderWidthQuarterpulse,
          borderColor: theme.colorFormsBorderReadonly,

          backgroundColor: theme.colorFormsFillReadonly,
        },
      },
      isError: {
        true: {
          borderWidth: theme.borderWidthQuarterpulse,
          borderColor: theme.colorFormsBorderError,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          isFocused: true,
          isFilled: true,
        },
        css: {
          backgroundColor: theme.colorFormsFillFocused,
          borderColor: 'black',
          borderWidth: theme.borderWidthHalfpulse,
        },
      },
      {
        variants: {
          isError: true,
          isFilled: true,
        },
        css: {
          backgroundColor: theme.colorFormsFillError,
        },
      },
    ],
  }
})
